import { useTranslation } from 'react-i18next'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { useViewMode } from '@/hooks/useViewMode'

export function ViewModeSwitch() {
  const { t } = useTranslation('common')
  const { viewAll, isAdmin, toggleViewMode } = useViewMode()

  if (!isAdmin) return null

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="view-mode"
        checked={viewAll}
        onCheckedChange={toggleViewMode}
      />
      <Label
        htmlFor="view-mode"
        className="text-sm text-muted-foreground cursor-pointer"
      >
        {t('viewMode.showAll')}
      </Label>
    </div>
  )
}
